module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAAXNSR0IB2cksfwAAADBQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWj8cCwAAABB0Uk5TAAwQBCg8QCwcODQwGCAUJAr6+ncAAABtSURBVHicY2BgYBBSZgABZte0tEIQQzUNCBoYGBjT0gra0jIYGDjBjDQBBiCRBZQrYNgGJI6lpSUwAHkX1NLSkhCMMAgjkcENwghgeAZhfGDgBjNSDRiYl6UtcgOqZWCwBurLFADZ+mRaONBOAFv0K6lQ49TwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/more-info.png
// module id = 872
// module chunks = 0